<template>
    <card-seplag >
        <div class="p-grid p-col-12" style="margin-top:10px;">
            <Rotulo cols="12 3" nome="Setor:">
                <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
                    placeholder="Selecione..." filter :disabled="false" @change="carregarDados()" />                
            </Rotulo>
        </div>
        <div class="p-grid p-col-12" style="margin-top:10px;">        
            <h1 class="p-col-12">Férias Validadas</h1>
        </div>        
        <DataTable :value="dadosTabelaValidados" :paginator="true" :rows="10" responsiveLayout="scroll" class="p-datatable-responsive table-seplag" style="width:100%">
            <Column field="matricula" header="Matrícula" :headerStyle="`width: 3%;`"></Column>
            <Column field="nome" header="Nome"></Column>
            <Column field="setor" header="Setor"></Column>            
            <Column header="Período de Aquisitivo" headerStyle="width: 14em"  bodyStyle="text-align: center;">
                <template #body="slotProps">
                    {{slotProps.data.dataInicioDireitoAfastamento? slotProps.data.dataInicioDireitoAfastamento+" à "+slotProps.data.dataFimDireitoAfastamento : ""}}
                    {{slotProps.data.dataInicioPeriodoAquisitivo?slotProps.data.dataInicioPeriodoAquisitivo+" à "+slotProps.data.dataFimPeriodoAquisitivo: ""}}
                </template>
            </Column>
            <Column  headerStyle="width: 14em" bodyStyle="text-align: center" header="Período de Usufruto">
                <template  #body="slotProps"> 
                        <span>{{slotProps.data.dataInicio}} à {{slotProps.data.dataFim}}</span>                       
                    </template>
            </Column>
            <Column  headerStyle="width: 10em; text-align: center" header="Dias de Afastamento">
                <template #body="slotProps"> 
                    <div style="text-align: center;">
                        <span>{{slotProps.data.totalDias? slotProps.data.totalDias: slotProps.data.dias? slotProps.data.dias: "" }} dias <br></span>                       
                        <span v-if="slotProps.data.tipoJornada=='REDUZIDA'">(<b>Redução de Jornada</b>)</span>
                        <span v-if="slotProps.data.tipoJornada=='INTEGRAL'">(<b>Usufruto</b>)</span><br>
                        <span><b>{{slotProps.data.tipo?slotProps.data.tipo: slotProps.data.title? slotProps.data.title.toUpperCase() : ""}}</b></span>
                    </div>
                </template>
            </Column>                 
        </DataTable>     
    </card-seplag> 
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl } from '@/config/global'
import Rotulo from '@/template/RotuloSeplag.vue'
export default {
    name:"feriasChefiaPendenteValidacao",
    components: { CardSeplag, Rotulo },    
    data: function(){
        return {        
            dadosTabelaValidados: [],
            apiUrlRecurso: "feriasview",
            urlPaginacao: null,
            totalRegistro: 0,
            tamanhoPorpagina: 1000,
            paginacaoTabela: '?size=1000&page=0',
            listaUnidades: null,
            unidadeSelecionada: null, 
        }
    },
    methods: { 
		async carregarDados(){  
            const matricula = this.$store.getters.getMatricula
            const vinculo = this.$store.getters.getVinculo
            this.urlPaginacao = `${this.apiUrlRecurso}/chefia/lista/APROVADO/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}`

            // Buscar unidades
            await this.$http.get(`${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${matricula}/${vinculo}`).then(respUnidades => {                    
                this.listaUnidades = respUnidades.data.map(function (element) {
                    return {
                        ...element,
                        labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
                    };
                });
                
            })

            this.unidadeSelecionada = this.unidadeSelecionada ? this.unidadeSelecionada : this.listaUnidades[0]

            this.$http.get(`${baseApiUrl}/${this.urlPaginacao}/${this.unidadeSelecionada.codgSeap}?size=${this.tamanhoPorpagina}&page=0`).then(res => {
               this.dadosTabelaValidados = res.data.content
               this.totalRegistro = res.data.totalElements
                this.$http.get(`${baseApiUrl}/programacaoafastamentos/chefia/aprovados/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/${this.$store.getters.getIdenPessoa}?size=${this.tamanhoPorpagina}&page=0`).then(res2 => {
                if( res2.data.totalElements > 0){
                    for(var i=0; i < res2.data.content.length;i++ ){
                        this.dadosTabelaValidados.push(res2.data.content[i])
                    }
                    this.totalRegistro = this.totalRegistro + res.data.totalElements
                }
            })

            })
        },
        adicionarRegistro(){
            // this.exibirTela = false
        }
    },
    mounted(){
		// Carrega os dados do serviço
		this.carregarDados()
    }
    
}
</script>

<style>

.customer-badge-validado {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #C8E6C9;
    color: #256029;
}
.customer-badge-negado {
    border-radius: 2px;
    padding: .25em .5em;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
    background-color: #FFCDD2;
    color: #C63737;
}

</style>